import { Wei } from '../../utils/types'
import {
  PoolQueryResult,
  PoolWithData,
  TokenWithData,
} from '../../api/api-types'
import { floorWei } from '../../utils/static-web3'
import { Token } from '../token/token'

export function calculateAfterOneAssetJoin(
  amountPutIn: Wei,
  tokenPutIn: Token,
  newPoolShares: Wei,
  pool: PoolWithData
) {
  const tokens = pool.tokens
  const map = new Map<TokenWithData, Wei>()
  const newShareNWei = Number(newPoolShares)
  const poolShareNWei = Number(pool.totalShares)
  const ratio = newShareNWei / (poolShareNWei + newShareNWei)

  for (const t of tokens) {
    const balanceWei = Number(t.balance)
    const amountWei = Number(amountPutIn)
    if (t === tokenPutIn) {
      // TODO issue https://github.com/swaap-labs/demo-v1/issues/40
      const tokenIn = ratio * (balanceWei + amountWei)
      map.set(t, floorWei(tokenIn))
    } else {
      const tokenIn = ratio * balanceWei
      map.set(t, floorWei(tokenIn))
    }
  }
  return map
}
